// Simple fix for position issue - minimal changes to original code
function myFunction() {
  var element = document.getElementById("dropdown-options-div");
  element.classList.toggle("active");
  document.querySelector(".select-compare-product-dropdown").classList.toggle("rotated");
}

document.addEventListener('DOMContentLoaded', function () {
  const popupElement = document.querySelector('.comparison-section-popup');
  const compareBtn = document.querySelector('.compare-product-btn');
  const checkboxes = document.querySelectorAll('.compare-checkbox');
  const comparisonText = document.querySelector('.comparison-text');
  const productPopup = document.querySelector('.comparison-product-popup');
  const comparisonStatusText = document.getElementById('comparison-status-text');
  const productoverlay = document.getElementById('overlay');
  
  // Product image containers
  const productImage1 = document.getElementById('product-image-1');
  const productImage2 = document.getElementById('product-image-2');
  
  // Get product info containers
  const allProductInfoContainers = document.querySelectorAll('.comparison-product-info');
  
  let skinTypeContainer1 = null;
  let skinTypeContainer2 = null;
  let textureContainer1 = null;
  let textureContainer2 = null;
  let finishContainer1 = null;
  let finishContainer2 = null;
  let benefitContainer1 = null;
  let benefitContainer2 = null;
  let waterResistantContainer1 = null;
  let waterResistantContainer2 = null;
  let fragranceContainer1 = null;
  let fragranceContainer2 = null;
  let titleContainer1 = null;
  let titleContainer2 = null;
  let priceContainer1 = null;
  let priceContainer2 = null;
  
  // SIMPLE FIX: Just track which position was removed
  let productPositionMap = new Map();
  let removedPosition = null; // Track which position needs to be filled
  
  // Function to update comparison status text
  function updateComparisonStatusText() {
    const checkedBoxes = document.querySelectorAll('.compare-checkbox:checked');
    const count = checkedBoxes.length;
    
    if (count === 1) {
      comparisonStatusText.innerHTML = 'Add one more <br> product to compare';
    } else if (count >= 2) {
      comparisonStatusText.innerHTML = 'Maximum selection <br>has been reached';
    } else {
      comparisonStatusText.innerHTML = 'Add one more <br> product to compare';
    }
  }
  
  // Function to truncate title
  function truncateTitle(title) {
    if (!title || title === '-') return title;
    
    const commaIndex = title.indexOf(',');
    if (commaIndex !== -1) {
      return title.substring(0, commaIndex).trim();
    }
    
    const words = title.split(' ');
    if (words.length > 3) {
      return words.slice(0, 3).join(' ');
    }
    
    return title;
  }
  
  // Get containers for products
  if (allProductInfoContainers[1]) {
    skinTypeContainer1 = allProductInfoContainers[1].querySelector('.comparison-product-skin-type');
    textureContainer1 = allProductInfoContainers[1].querySelector('.comparison-product-texture-type');
    finishContainer1 = allProductInfoContainers[1].querySelector('.comparison-product-finish-type');
    benefitContainer1 = allProductInfoContainers[1].querySelector('.comparison-product-benefit-type');
    waterResistantContainer1 = allProductInfoContainers[1].querySelector('.comparison-product-water-resistant-type');
    fragranceContainer1 = allProductInfoContainers[1].querySelector('.comparison-product-fragrance-type');
    titleContainer1 = allProductInfoContainers[1].querySelector('.comparison-product-title');
    priceContainer1 = allProductInfoContainers[1].querySelector('.comparison-product-price-type, .comparison-product-Price-type');
  }
  
  if (allProductInfoContainers[2]) {
    skinTypeContainer2 = allProductInfoContainers[2].querySelector('.comparison-product-skin-type');
    textureContainer2 = allProductInfoContainers[2].querySelector('.comparison-product-texture-type');
    finishContainer2 = allProductInfoContainers[2].querySelector('.comparison-product-finish-type');
    benefitContainer2 = allProductInfoContainers[2].querySelector('.comparison-product-benefit-type');
    waterResistantContainer2 = allProductInfoContainers[2].querySelector('.comparison-product-water-resistant-type');
    fragranceContainer2 = allProductInfoContainers[2].querySelector('.comparison-product-fragrance-type');
    titleContainer2 = allProductInfoContainers[2].querySelector('.comparison-product-title');
    priceContainer2 = allProductInfoContainers[2].querySelector('.comparison-product-price-type, .comparison-product-Price-type');
  }
  
  // Clear all cookies on page load
  clearAllComparisonCookies();
  
  let selectedProductIds = [];
  
  // Function to populate dropdown
  function populateDropdown() {
    const dropdown = document.getElementById('select-compare-product');
    if (!dropdown) {
      console.log('Dropdown not found');
      return;
    }
    
    const dropdownOptions = dropdown.querySelector('.dropdown-options');
    if (!dropdownOptions) {
      console.log('Dropdown options container not found');
      return;
    }
    
    // Clear existing options
    dropdownOptions.innerHTML = '';
    
    // Get currently checked products
    const currentlyCheckedProductIds = [];
    const checkedCheckboxes = document.querySelectorAll('.compare-checkbox:checked');
    
    checkedCheckboxes.forEach(function(checkbox) {
      const productCard = checkbox.closest('.card-product-print');
      if (productCard) {
        const productId = productCard.getAttribute('data-product-id');
        if (productId) {
          currentlyCheckedProductIds.push(productId);
        }
      }
    });
    
    // Find all available products
    const productCards = document.querySelectorAll('.card-product-print');
    const availableProducts = [];
    
    productCards.forEach(function(productCard) {
      const comparisonMetafield = productCard.querySelector('#sunscreen-dnk_add_comparison');
      
      if (comparisonMetafield && comparisonMetafield.value === 'true') {
        const productId = productCard.getAttribute('data-product-id');
        const productTitle = productCard.querySelector('#sunscreen-compare-product-title')?.value || 'Unknown Product';
        const variantId = productCard.querySelector('#sunscreen-compare-product-id')?.value || '';
        
        // Only add products that are NOT currently checked
        if (!currentlyCheckedProductIds.includes(productId)) {
          availableProducts.push({
            id: productId,
            variantId: variantId,
            title: productTitle,
            productCard: productCard
          });
        }
      }
    });
    
    // Add options to dropdown
    availableProducts.forEach(function(product) {
      const optionDiv = document.createElement('div');
      optionDiv.className = 'dropdown-option';
      optionDiv.setAttribute('data-value', product.id);
      optionDiv.setAttribute('data-variant-id', product.variantId);
      optionDiv.textContent = truncateTitle(product.title);
      dropdownOptions.appendChild(optionDiv);
    });
    
    console.log('Populated dropdown with', availableProducts.length, 'available products');
  }
  
  // FIXED: Handle dropdown selection with position awareness
  function handleDropdownSelection() {
    const dropdown = document.getElementById('select-compare-product');
    if (!dropdown) {
      console.log('Dropdown not found for event handling');
      return;
    }
    
    const dropdownSelected = dropdown.querySelector('.dropdown-selected');
    const dropdownOptions = dropdown.querySelector('.dropdown-options');

    dropdownOptions.addEventListener('click', function(e) {
      if (e.target && e.target.classList.contains('dropdown-option')) {
        const selectedProductId = e.target.getAttribute('data-value');
        const selectedText = e.target.textContent;
        
        if (selectedProductId) {
          console.log('Selected product from dropdown:', selectedProductId);
          console.log('Removed position was:', removedPosition);
          
          // Update selected text
          dropdownSelected.textContent = selectedText;
          dropdownOptions.style.display = 'none';
          
          // Find and check the corresponding checkbox
          const productCards = document.querySelectorAll('.card-product-print');
          
          productCards.forEach(function(productCard) {
            const productId = productCard.getAttribute('data-product-id');
            
            if (productId === selectedProductId) {
              const checkbox = productCard.querySelector('.compare-checkbox');
              
              if (checkbox && !checkbox.checked) {
                checkbox.checked = true;
                
                // POSITION FIX: Map this product to the removed position
                if (removedPosition) {
                  productPositionMap.set(removedPosition, selectedProductId);
                  console.log(`Mapped product ${selectedProductId} to position ${removedPosition}`);
                  removedPosition = null; // Clear the removed position
                }
                
                // Save checkbox state
                const allCheckboxes = document.querySelectorAll('.compare-checkbox');
                let checkboxIndex = -1;
                
                for (let i = 0; i < allCheckboxes.length; i++) {
                  if (allCheckboxes[i] === checkbox) {
                    checkboxIndex = i;
                    break;
                  }
                }
                
                if (checkboxIndex !== -1) {
                  setCookie('checkbox_' + checkboxIndex, true, 30);
                }
                
                // Update selected products array
                if (!selectedProductIds.includes(productId)) {
                  selectedProductIds.push(productId);
                  setCookie('selected_product_ids', JSON.stringify(selectedProductIds), 30);
                }
                
                console.log('Checked product:', productId);
              }
            }
          });
          
          // Update state and product info
          updateState();
          updateProductInfo();
          
          // Reset dropdown text
          setTimeout(() => {
            dropdownSelected.textContent = 'Select';
          }, 100);
          
          populateDropdown();
          updateComparisonStatusText();
        }
      }
    });
  }

  // IMPROVED: Update product information with position handling
  function updateProductInfo() {
    // Clear containers
    if (productImage1) productImage1.innerHTML = '';
    if (productImage2) productImage2.innerHTML = '';
    
    [skinTypeContainer1, skinTypeContainer2, textureContainer1, textureContainer2,
     finishContainer1, finishContainer2, benefitContainer1, benefitContainer2,
     waterResistantContainer1, waterResistantContainer2, fragranceContainer1, fragranceContainer2,
     titleContainer1, titleContainer2, priceContainer1, priceContainer2].forEach(container => {
      if (container) container.innerHTML = '';
    });
    
    const checkedBoxes = document.querySelectorAll('.compare-checkbox:checked');
    console.log('Checked checkboxes:', checkedBoxes.length);
    console.log('Current position map:', productPositionMap);
    
    // Show/hide UI elements
    const sunscreenCard = document.querySelector('.comparison-product-info.add-sunscreen');
    if (checkedBoxes.length >= 2) {
      if (sunscreenCard) sunscreenCard.classList.add('hidden');
    } else {
      if (sunscreenCard) sunscreenCard.classList.remove('hidden');
    }
    
    if (checkedBoxes.length >= 1) {
      if (allProductInfoContainers[1]) allProductInfoContainers[1].classList.remove('hidden');
    } else {
      if (allProductInfoContainers[1]) allProductInfoContainers[1].classList.add('hidden');
    }
    
    if (checkedBoxes.length >= 2) {
      if (allProductInfoContainers[2]) allProductInfoContainers[2].classList.remove('hidden');
    } else {
      if (allProductInfoContainers[2]) allProductInfoContainers[2].classList.add('hidden');
    }
    
    // Show close buttons
    if (checkedBoxes.length > 0) {
      document.querySelectorAll('.comparison-close-product').forEach(function(btn) {
        btn.classList.remove('hidden');
      });
    } else {
      document.querySelectorAll('.comparison-close-product').forEach(function(btn) {
        btn.classList.add('hidden');
      });
    }
    
    // FIXED: Process products based on their mapped positions
    // First update the position map for new selections
    checkedBoxes.forEach(function(checkbox) {
      const productCard = checkbox.closest('.card-product-print');
      if (productCard) {
        const productId = productCard.getAttribute('data-product-id');
        
        // Check if this product is already mapped to a position
        let foundInMap = false;
        for (let [position, mappedId] of productPositionMap) {
          if (mappedId === productId) {
            foundInMap = true;
            break;
          }
        }
        
        // If not found in map, add to next available position
        if (!foundInMap) {
          if (!productPositionMap.has(1)) {
            productPositionMap.set(1, productId);
          } else if (!productPositionMap.has(2)) {
            productPositionMap.set(2, productId);
          }
        }
      }
    });
    
    console.log('Position map before rendering:', productPositionMap);
    
    // IMPORTANT: Clear position map of products that are no longer checked
    const currentCheckedProductIds = [];
    checkedBoxes.forEach(function(checkbox) {
      const productCard = checkbox.closest('.card-product-print');
      if (productCard) {
        const productId = productCard.getAttribute('data-product-id');
        if (productId) {
          currentCheckedProductIds.push(productId);
        }
      }
    });
    
    // Clean up position map - remove products that are no longer checked
    for (let [position, productId] of productPositionMap) {
      if (!currentCheckedProductIds.includes(productId)) {
        productPositionMap.delete(position);
      }
    }
    
    // If only one product left and it's in position 2, move it to position 1
    if (checkedBoxes.length === 1 && productPositionMap.has(2) && !productPositionMap.has(1)) {
      const productId = productPositionMap.get(2);
      productPositionMap.delete(2);
      productPositionMap.set(1, productId);
      console.log(`Moved single product ${productId} from position 2 to position 1`);
    }
    
    // Render products based on position map
    [1, 2].forEach(position => {
      const productId = productPositionMap.get(position);
      
      if (productId) {
        // Find the product card with this ID
        const productCards = document.querySelectorAll('.card-product-print');
        
        productCards.forEach(function(productCard) {
          const cardProductId = productCard.getAttribute('data-product-id');
          
          if (cardProductId === productId) {
            const checkbox = productCard.querySelector('.compare-checkbox');
            
            if (checkbox && checkbox.checked) {
              console.log(`Processing product ${productId} for position ${position}`);
              
              // Get all product data
              const skinType = productCard.querySelector('#sunscreen-compare-product-skin-type')?.value || '-';
              const texture = productCard.querySelector('#sunscreen-compare-product-texture')?.value || '-';
              const finish = productCard.querySelector('#sunscreen-compare-product-finish')?.value || '-';
              const benefit = productCard.querySelector('#sunscreen-compare-product-benefit')?.value || '-';
              const waterResistant = productCard.querySelector('#sunscreen-compare-product-water-resistant')?.value || '-';
              const fragrance = productCard.querySelector('#sunscreen-compare-product-fragrance')?.value || '-';
              const title = productCard.querySelector('#sunscreen-compare-product-title')?.value || '-';
              const rawPrice = productCard.querySelector('#sunscreen-compare-product-price')?.value || '-';
              const titleColor = productCard.querySelector('#sunscreen-dnk-pdp-primary-color')?.value || '';
              const primaryColor = productCard.querySelector('#sunscreen-dnk-bg-color')?.value || '';
              
              const truncatedTitle = truncateTitle(title);
              const variantId = productCard.querySelector('#sunscreen-compare-product-id')?.value || '';
              
              // Format price
              let formattedPrice = rawPrice;
              if (rawPrice !== '-' && rawPrice !== '') {
                const priceNumber = parseFloat(rawPrice) / 100;
                formattedPrice = Math.round(priceNumber).toString();
              }
              
              // Create elements
              const createParagraph = (text) => {
                const p = document.createElement('p');
                p.textContent = text;
                return p;
              };
              
              const priceParagraph = document.createElement('p');
              priceParagraph.className = 'money-print';
              const currencySpan = document.createElement('span');
              currencySpan.className = 'non-bold';
              currencySpan.textContent = '₹';
              priceParagraph.appendChild(currencySpan);
              priceParagraph.appendChild(document.createTextNode(formattedPrice !== '-' ? formattedPrice : '-'));
              
              // Add to containers based on position
              if (position === 1) {
                if (skinTypeContainer1) skinTypeContainer1.appendChild(createParagraph(skinType));
                if (textureContainer1) textureContainer1.appendChild(createParagraph(texture));
                if (finishContainer1) finishContainer1.appendChild(createParagraph(finish));
                if (benefitContainer1) benefitContainer1.appendChild(createParagraph(benefit));
                if (waterResistantContainer1) waterResistantContainer1.appendChild(createParagraph(waterResistant));
                if (fragranceContainer1) fragranceContainer1.appendChild(createParagraph(fragrance));
                if (titleContainer1) {
                  titleContainer1.appendChild(createParagraph(truncatedTitle));
                  if (titleColor) titleContainer1.style.backgroundColor = titleColor;
                }
                if (priceContainer1) priceContainer1.appendChild(priceParagraph);
                
                if (primaryColor && allProductInfoContainers[1]) {
                  const comparisonTexts = allProductInfoContainers[1].querySelectorAll('.comparison-text');
                  comparisonTexts.forEach(function(textEl) {
                    textEl.style.backgroundColor = primaryColor;
                  });
                }
              } else if (position === 2) {
                if (skinTypeContainer2) skinTypeContainer2.appendChild(createParagraph(skinType));
                if (textureContainer2) textureContainer2.appendChild(createParagraph(texture));
                if (finishContainer2) finishContainer2.appendChild(createParagraph(finish));
                if (benefitContainer2) benefitContainer2.appendChild(createParagraph(benefit));
                if (waterResistantContainer2) waterResistantContainer2.appendChild(createParagraph(waterResistant));
                if (fragranceContainer2) fragranceContainer2.appendChild(createParagraph(fragrance));
                if (titleContainer2) {
                  titleContainer2.appendChild(createParagraph(truncatedTitle));
                  if (titleColor) titleContainer2.style.backgroundColor = titleColor;
                }
                if (priceContainer2) priceContainer2.appendChild(priceParagraph.cloneNode(true));
                
                if (primaryColor && allProductInfoContainers[2]) {
                  const comparisonTexts = allProductInfoContainers[2].querySelectorAll('.comparison-text');
                  comparisonTexts.forEach(function(textEl) {
                    textEl.style.backgroundColor = primaryColor;
                  });
                }
              }
              
              // Update add to cart form
              const targetContainer = position === 1 ? allProductInfoContainers[1] : allProductInfoContainers[2];
              if (targetContainer && variantId) {
                const productForm = targetContainer.querySelector('product-form');
                if (productForm) {
                  const variantInput = productForm.querySelector('.product-variant-id');
                  const addToCartButton = productForm.querySelector('.quiz_add_to_cart');
                  
                  if (variantInput) variantInput.value = variantId;
                  if (addToCartButton) {
                    addToCartButton.setAttribute('data-product-id', variantId);
                    addToCartButton.setAttribute('data-product-title', title);
                  }
                }
              }
              
              // Add image
              const imageContainer = productCard.querySelector('.fxd-product-card-image');
              if (imageContainer) {
                const productImg = imageContainer.querySelector('img');
                
                if (productImg) {
                  const imgClone = productImg.cloneNode(true);
                  const targetImageContainer = position === 1 ? productImage1 : productImage2;
                  
                  if (targetImageContainer) {
                    targetImageContainer.appendChild(imgClone);
                    
                    const titleDiv = document.createElement('div');
                    titleDiv.className = 'comparison-product-title';
                    if (titleColor) titleDiv.style.backgroundColor = titleColor;
                    
                    const titleParagraphInImage = document.createElement('p');
                    titleParagraphInImage.textContent = truncatedTitle;
                    titleDiv.appendChild(titleParagraphInImage);
                    
                    targetImageContainer.appendChild(titleDiv);
                  }
                }
              }
            }
          }
        });
      }
    });
  }

  // Initialize checkboxes
  checkboxes.forEach(function (checkbox, index) {
    checkbox.checked = false;

    checkbox.addEventListener('change', function () {
      setCookie('checkbox_' + index, this.checked, 30);

      const productCard = this.closest('.card-product-print');
      if (productCard) {
        const productId = productCard.getAttribute('data-product-id');
        if (productId) {
          if (this.checked) {
            selectedProductIds.push(productId);
          } else {
            selectedProductIds = selectedProductIds.filter(id => id !== productId);
            
            // Remove from position map when unchecked
            for (let [position, mappedId] of productPositionMap) {
              if (mappedId === productId) {
                productPositionMap.delete(position);
                break;
              }
            }
          }
          setCookie('selected_product_ids', JSON.stringify(selectedProductIds), 30);
        }
      }

      updateState();
      updateProductInfo();
      populateDropdown();
      updateComparisonStatusText();
    });
  });

  // Initial setup
  updateState();
  updateProductInfo();
  populateDropdown();
  handleDropdownSelection();
  updateComparisonStatusText();
  
  function updateState() {
    const checkedBoxes = [...checkboxes].filter(cb => cb.checked);
    const count = checkedBoxes.length;

    compareBtn.textContent = `COMPARE (${count})`;
    compareBtn.disabled = count < 2;
    popupElement.classList.toggle('active', count > 0);

    checkboxes.forEach(cb => {
     cb.disabled = !cb.checked && count >= 2;
   });
 }

 // Close comparison popup
 document.querySelector('.close-comparison-popup').addEventListener('click', function () {
   $('body').css('overflow', 'auto');
   productPopup.classList.remove('active');
   productoverlay.classList.remove('active');

   checkboxes.forEach(function(checkbox, index) {
     checkbox.checked = false;
     setCookie('checkbox_' + index, false, 30);
   });
   
   selectedProductIds = [];
   setCookie('selected_product_ids', JSON.stringify(selectedProductIds), 30);
   
   // Clear position tracking
   productPositionMap.clear();
   removedPosition = null;
   
   updateState();
   updateProductInfo();
   populateDropdown();
   updateComparisonStatusText();
 });

 document.querySelector('.close-comparison-div').addEventListener('click', function () {
   $('body').css('overflow', 'auto');
   productPopup.classList.remove('active');
   productoverlay.classList.remove('active');

   checkboxes.forEach(function(checkbox, index) {
     checkbox.checked = false;
     setCookie('checkbox_' + index, false, 30);
   });
   
   selectedProductIds = [];
   setCookie('selected_product_ids', JSON.stringify(selectedProductIds), 30);
   
   // Clear position tracking
   productPositionMap.clear();
   removedPosition = null;
   
   updateState();
   updateProductInfo();
   populateDropdown();
   updateComparisonStatusText();
 });

 // Compare button click
 compareBtn.addEventListener('click', function () { 
   $('body').css('overflow', 'hidden');
   const checkedBoxes = document.querySelectorAll('.compare-checkbox:checked');
   if (checkedBoxes.length >= 2) {
     updateProductInfo();
     productPopup.classList.add('active');
     productoverlay.classList.add('active');
   }
 });

 // Clear all functionality
 document.addEventListener('click', function(e) {
   if (e.target.classList.contains('clear-all-btn')) {
     checkboxes.forEach(function(checkbox, index) {
       checkbox.checked = false;
       setCookie('checkbox_' + index, false, 30);
     });
     
     selectedProductIds = [];
     setCookie('selected_product_ids', JSON.stringify(selectedProductIds), 30);
     
     // Clear position tracking
     productPositionMap.clear();
     removedPosition = null;
     
     updateState();
     updateProductInfo();
     populateDropdown();
     updateComparisonStatusText();
   }
 });

 // FIXED: Handle close product functionality with position tracking
 document.addEventListener('click', function(e) {
   if (e.target.classList.contains('comparison-close-product')) {
     const parent = e.target.closest('.comparison-product-info');
     const allContainers = document.querySelectorAll('.comparison-product-info');
     
     let containerIndex = -1;
     for (let i = 0; i < allContainers.length; i++) {
       if (allContainers[i] === parent) {
         containerIndex = i;
         break;
       }
     }
     
     let productIdToRemove = null;
     let positionRemoved = null;
     
     if (containerIndex === 1) {
       positionRemoved = 1;
       productIdToRemove = productPositionMap.get(1);
     } else if (containerIndex === 2) {
       positionRemoved = 2;
       productIdToRemove = productPositionMap.get(2);
     }
     
     if (productIdToRemove && positionRemoved) {
       console.log(`Removing product ${productIdToRemove} from position ${positionRemoved}`);
       
       // Remove from position map
       productPositionMap.delete(positionRemoved);
       
       // SPECIAL FIX: When first product is removed, shift second product to first position
       if (positionRemoved === 1 && productPositionMap.has(2)) {
         const secondProductId = productPositionMap.get(2);
         productPositionMap.delete(2);
         productPositionMap.set(1, secondProductId);
         console.log(`Shifted product ${secondProductId} from position 2 to position 1`);
         removedPosition = 2; // Next product should go to position 2
       } else {
         // Normal case - track which position was removed for next addition
         removedPosition = positionRemoved;
       }
       
       checkboxes.forEach(function(checkbox, index) {
         const productCard = checkbox.closest('.card-product-print');
         if (productCard) {
           const productId = productCard.getAttribute('data-product-id');
           if (productId === productIdToRemove && checkbox.checked) {
             checkbox.checked = false;
             setCookie('checkbox_' + index, false, 30);
             
             selectedProductIds = selectedProductIds.filter(id => id !== productId);
             setCookie('selected_product_ids', JSON.stringify(selectedProductIds), 30);
             return;
           }
         }
       });
       
       console.log('Current position map after removal:', productPositionMap);
       console.log('Next product will go to position:', removedPosition);
     }
     
     updateState();
     updateProductInfo();
     populateDropdown();
     updateComparisonStatusText();
   }
 });
});

// Helper functions
function clearAllComparisonCookies() {
  for (let i = 0; i < 100; i++) {
    setCookie('checkbox_' + i, '', -1);
  }
  setCookie('selected_product_ids', '', -1);
}

function getSelectedProductIdsFromCookie() {
 const json = getCookie('selected_product_ids');
 try {
   const arr = JSON.parse(json);
   return Array.isArray(arr) ? arr : [];
 } catch {
   return [];
 }
}

function setCookie(name, value, days) {
 let expires = "";
 if (days) {
   const date = new Date();
   date.setTime(date.getTime() + (days * 86400000));
   expires = "; expires=" + date.toUTCString();
 }
 document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function getCookie(name) {
 const nameEQ = name + "=";
 const ca = document.cookie.split(';');
 for (let i = 0; i < ca.length; i++) {
   let c = ca[i];
   while (c.charAt(0) === ' ') c = c.substring(1);
   if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
 }
 return null;
}